/**
 *  load google maps in the contacts page
 */

/**
 * Load google maps script
 *
 */
function loadGoogleMapsWrapper() {
    var lang = $('html').attr('lang');
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.async = true;
    var google_maps_api_key = 'AIzaSyCMUd2vYrORULd1whurtcopIakDOwsh5wc';
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + google_maps_api_key + '&language=' + lang + '&callback=initMap';
    document.body.appendChild(script);
}

function initMap() {

    var $map = $('#map'),
        $map_data = $('#Fieldtype_map'),
        marker_info = new String($('#markerinfo').val()),
        value = new String($map_data.val()),
        value = value.split('[===]'),
        map_settings = value[0],
        map_settings = map_settings.split('[---]');

    var mapCenter = new google.maps.LatLng(parseFloat(map_settings[0]), parseFloat(map_settings[1]));

    var myOptions = {
        zoom: parseInt(map_settings[2]),
        center: mapCenter,
        mapTypeId: map_settings[3],
        zoomControl: true,
        panControl: false,
        scrollwheel: false,
        backgroundColor: '#dedede',
        streetViewControl: false,
        scaleControl: false,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.RIGHT_TOP
        }
    };

    var stylez = [{
        featureType: 'all',
        elementType: 'all',
        stylers: [
            { saturation: -100 }
        ]
    }];

    google.maps.visualRefresh = true;
    this.gmap = new google.maps.Map($map.get(0), myOptions);
    this.gmap.setOptions({styles: stylez});
    this.infowindow = new google.maps.InfoWindow({maxWidth: 400});

    google.maps.event.addDomListener(window, "resize", function() {
        var center = gmap.getCenter();
        google.maps.event.trigger(gmap, "resize");
        gmap.setCenter(center);
    });

    this.markers = new Array();

    map_clickListener(this);

    for (var i = 1; i < value.length; i++) {
        var latlng = value[i];
        latlng = latlng.split('[---]');

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(latlng[0]), parseFloat(latlng[1])),
            map: this.gmap,
            _map: this,
            info: marker_info,
            draggable: false
        });

        console.log(marker_info);

        this.markers[this.markers.length] = marker;

        marker_clickListener(marker);
        openInfoWindow(marker);
    }
}

function map_clickListener(map) {
    map.clickListener = google.maps.event.addListener(map.gmap, "click", function (event) {
        map.infowindow.close();
    });
}

function marker_clickListener(marker) {
    marker.clickListener = google.maps.event.addListener(marker, "click", function () {
        openInfoWindow(marker);
    });
}

function openInfoWindow(marker) {
    if (marker.info.length > 0) {
        var content = '<div class="map__info_window">' + marker.info + '</div>';
        marker._map.infowindow.marker = marker;
        marker._map.infowindow.setContent(content);
        marker._map.infowindow.open(marker.map, marker);
    }
}


$(function() {
    'use strict';

    /**
     * Initialize Google Map in the Contact page
     */
    var $mapCanvas = $('#map');
    if ($mapCanvas.length) {
        loadGoogleMapsWrapper();
    }
});

